import { ORDER_TYPE } from "@/lib/orderType";

const CART_COOKIE_KEYS = {
  [ORDER_TYPE.GROCERY]: "asian_basket_grocery_cart_id",
  [ORDER_TYPE.TAKEOUT]: "asian_basket_takeout_cart_id",
};

const THIRTY_DAYS = 60 * 60 * 24 * 30;

function canUseDocument() {
  return typeof document !== "undefined";
}

export function getCartCookieKey(orderType) {
  return CART_COOKIE_KEYS[orderType] || CART_COOKIE_KEYS[ORDER_TYPE.GROCERY];
}

export function getCartIdCookie(orderType) {
  if (!canUseDocument()) return "";

  const key = `${getCartCookieKey(orderType)}=`;
  const entry = document.cookie
    .split(";")
    .map((item) => item.trim())
    .find((item) => item.startsWith(key));

  return entry ? decodeURIComponent(entry.slice(key.length)) : "";
}

export function setCartIdCookie(orderType, cartId) {
  if (!canUseDocument() || !cartId) return;

  const secure = window.location.protocol === "https:" ? "; Secure" : "";
  document.cookie = `${getCartCookieKey(orderType)}=${encodeURIComponent(
    cartId,
  )}; Path=/; Max-Age=${THIRTY_DAYS}; SameSite=Lax${secure}`;
}

export function removeCartIdCookie(orderType) {
  if (!canUseDocument()) return;

  const secure = window.location.protocol === "https:" ? "; Secure" : "";
  document.cookie = `${getCartCookieKey(
    orderType,
  )}=; Path=/; Max-Age=0; SameSite=Lax${secure}`;
}
